<template>
    <button
        class="c-button-wrapper btn"
        :class="`btn-${btnVariant} btn-${size}`"
        :type="type"
        :disabled="disabled"
        @click="emit('click', $event)"
        @mousedown="emit('mousedown', $event)"
        @mouseup="emit('mouseup', $event)"
    >
        <template v-if="!slots.default || prioritizeContent">
            <font-awesome-icon v-if="icon" :icon="icon" :class="{ 'mr-2': text && text.length }" />
            {{ text }}
        </template>
        <slot />
    </button>
</template>

<script setup lang="ts">
import { ButtonHTMLAttributes, computed, useSlots } from 'vue';
import { CButtonVariant } from '.';

type ButtonSize = 'md' | 'sm' | 'lg' | 'icon';

const props = withDefaults(
    defineProps<{
        text?: string;
        icon?: string | string[];
        size?: ButtonSize;
        variant?: CButtonVariant;
        disabled?: boolean;
        type?: ButtonHTMLAttributes['type'];
        /**
         * Since ng-vue inserts default slots on vue components used in
         * angular view, this prop is needed
         */
        prioritizeContent?: boolean;
    }>(),
    { type: 'button', size: 'md' }
);

const emit = defineEmits<{
    (event: 'click', value: MouseEvent): void;
    (event: 'mousedown', value: MouseEvent): void;
    (event: 'mouseup', value: MouseEvent): void;
}>();

const slots = useSlots();

const btnVariant = computed(() => (props.variant?.length ? props.variant : 'empty'));
</script>

<style lang="scss" scoped>
@import 'styles/utilities/functions';

.c-button-wrapper {
    font-weight: normal !important;
    &.btn,
    &:focus,
    &:hover {
        box-shadow: none !important;
    }
    &.btn-empty:hover {
        background-color: get-color('gray-200');
    }
    &.btn-icon {
        line-height: 0;
        padding: 0.313rem;
    }
}
</style>
